import React, { Component } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import StudentMarksBody from "../StudentMarksBody/StudentMarksBody";
import StudentMarksDetail from "../StudentMarksDetail/StudentMarksDetail";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class StudentMarksView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Full Name" },
        { name: "Class" },
        { name: "Faculty" },
        { name: "Group" },
        { name: "Section" },
        { name: "Actions" },
      ],
      detailStatus: false,
      studentDetail: {},
      marksStatus: false,
      marksDetails: [],
    };
  }

  handleDetailStatus = async (studentDetail) => {
    this.setState({
      detailStatus: true,
      studentDetail,
    });
    try {
      const response = await Axios.get(`${url}/api/marks`, {
        params: {
          session: this.props.examConfig.session,
          examType: this.props.examConfig.exam,
          studentClass: this.props.examConfig.class,
          faculty: this.props.examConfig.faculty
            ? this.props.examConfig.faculty
            : null,
          group: this.props.examConfig.group
            ? this.props.examConfig.group
            : null,
          section: this.props.examConfig.section,
          studentId: studentDetail._id,
        },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.marks.length !== 0) {
        this.setState({
          marksStatus: true,
          marksDetails: response.data.marks[0].marks,
        });
      } else {
        this.setState({
          marksStatus: false,
          marksDetails: this.props.initialMarksList,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDetailStatus(studentDetail);
      }
    }
  };

  handleCancelDetailStatus = () => {
    this.setState({
      detailStatus: false,
    });
  };

  render() {
    const { detailStatus, studentDetail } = this.state;
    const { students, isEmpty } = this.props;
    return (
      <div>
        <Grid container spacing={3}>
          {detailStatus === false ? (
            <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
              <Paper>
                <TableContainer>
                  <Table>
                    {students.length !== 0 && (
                      <CustomTableHead column={this.state.column} />
                    )}
                    <TableBody>
                      {students.length !== 0 ? (
                        students.map((student, index) => (
                          <StudentMarksBody
                            key={index}
                            index={index}
                            student={student}
                            handleDetailStatus={this.handleDetailStatus}
                          />
                        ))
                      ) : isEmpty ? (
                        <CustomEmptyMessage description="Select above options to get list of students" />
                      ) : (
                        <CustomSiteLoader />
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          ) : (
            <Grid item sx={12} sm={12} md={12} xl={12} lg={12}>
              <Paper>
                <StudentMarksDetail
                  student={studentDetail}
                  studentId={studentDetail._id}
                  initialMarksList={this.props.initialMarksList}
                  examConfig={this.props.examConfig}
                  marksStatus={this.state.marksStatus}
                  marksDetails={this.state.marksDetails}
                  handleCancelDetailStatus={this.handleCancelDetailStatus}
                />
              </Paper>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentMarksView);
